import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 17h6l-4 -5l4 -5h-6l-4 5l4 5","key":"svg-0"}]]

const IconArrowBadgeLeft = createReactComponent('outline', 'arrow-badge-left', 'ArrowBadgeLeft', __iconNode);

export default IconArrowBadgeLeft;